/* =====================================================================
   Glimmer — Favoritos
   Salva os produtos favoritados no próprio navegador do cliente (localStorage),
   sem login e sem servidor. Some se o cliente limpar os dados do navegador e
   não aparece em outro aparelho.

   Cada favorito é guardado como "HANDLE" (produto, sem variante escolhida)
   ou "HANDLE::VARIANT_ID" (produto + a cor/tamanho escolhido na página do produto).

   Marcação usada:
     <button data-glimmer-fav="HANDLE">                         coração (alterna)
     <button data-glimmer-fav="HANDLE" data-glimmer-fav-variant="ID">  coração que guarda a variante
     <span data-glimmer-fav-count>                              contador (cabeçalho)
     <div data-glimmer-fav-page>                                página "Meus favoritos"
   ===================================================================== */
(function () {
  if (window.GlimmerFavoritos) { return; }

  var KEY = 'glimmer_favoritos';
  var MAX = 100;
  var SEP = '::';

  function parse(entry) {
    var parts = String(entry).split(SEP);
    return { handle: parts[0], variant: parts[1] ? parseInt(parts[1], 10) || null : null };
  }

  function entryFor(handle, variant) { return variant ? handle + SEP + variant : handle; }

  function read() {
    try {
      var list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }

  function indexOfHandle(list, handle) {
    for (var i = 0; i < list.length; i++) { if (parse(list[i]).handle === handle) { return i; } }
    return -1;
  }

  function has(handle) { return indexOfHandle(read(), handle) !== -1; }

  // variant (opcional): id da variante escolhida. Um produto aparece uma vez só na lista.
  //  - não está salvo            -> adiciona (com a variante, se veio)
  //  - salvo com a mesma variante -> remove
  //  - salvo com outra variante   -> troca pela nova (o cliente mudou a cor e favoritou de novo)
  //  - coração sem variante       -> remove
  function toggle(handle, variant) {
    var list = read();
    var index = indexOfHandle(list, handle);
    var message, added;

    if (index === -1) {
      list.unshift(entryFor(handle, variant));
      added = true;
      message = 'Adicionado aos favoritos';
    } else if (variant && parse(list[index]).variant !== variant) {
      list.splice(index, 1);
      list.unshift(entryFor(handle, variant));
      added = true;
      message = 'Favorito atualizado com esta opção';
    } else {
      list.splice(index, 1);
      added = false;
      message = 'Removido dos favoritos';
    }

    write(list);
    refresh();
    toast(message);
    document.dispatchEvent(new CustomEvent('glimmer:favoritos', { detail: { handle: handle, variant: variant || null, added: added, list: read() } }));
    return added;
  }

  // Atualiza todos os corações e contadores da página.
  // Coração com variante só fica "cheio" quando aquela variante é a salva.
  function refresh() {
    var list = read();
    document.querySelectorAll('[data-glimmer-fav]').forEach(function (btn) {
      var handle = btn.getAttribute('data-glimmer-fav');
      var variant = parseInt(btn.getAttribute('data-glimmer-fav-variant'), 10) || null;
      var index = indexOfHandle(list, handle);
      var saved = index === -1 ? null : parse(list[index]);
      var on = !!saved && (!variant || !saved.variant || saved.variant === variant);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remover dos favoritos' : 'Adicionar aos favoritos');
    });
    document.querySelectorAll('[data-glimmer-fav-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }

  var toastTimer;
  function toast(message) {
    var el = document.querySelector('.glimmer-fav-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'glimmer-fav-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.innerHTML = '<span></span><a href="/search?view=favoritos">Ver favoritos</a>';
    el.firstChild.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  // Clique em qualquer coração (inclusive os que aparecem depois, como no carrinho re-renderizado).
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-glimmer-fav]');
    if (!btn) { return; }
    // O coração fica por cima da foto, que é um link: não deixa abrir o produto.
    event.preventDefault();
    event.stopPropagation();
    toggle(btn.getAttribute('data-glimmer-fav'), parseInt(btn.getAttribute('data-glimmer-fav-variant'), 10) || null);
  }, true);

  // Página do produto: o coração acompanha a variante escolhida (cor, tamanho...).
  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || !event.target.querySelectorAll) { return; }
    event.target.querySelectorAll('[data-glimmer-fav-variant]').forEach(function (btn) {
      btn.setAttribute('data-glimmer-fav-variant', variant.id);
    });
    refresh();
  });

  // Outra aba mudou os favoritos: atualiza esta.
  window.addEventListener('storage', function (event) { if (event.key === KEY) { refresh(); renderPage(); } });

  /* ---------------- Página "Meus favoritos" ---------------- */

  function money(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function escapeHtml(text) {
    return String(text).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sizedImage(src, size) {
    return src ? src.replace(/(\.[a-z]+)(\?|$)/i, '_' + size + '$1$2') : '';
  }

  function renderPage() {
    var root = document.querySelector('[data-glimmer-fav-page]');
    if (!root) { return; }
    var grid = root.querySelector('[data-glimmer-fav-grid]');
    var empty = root.querySelector('[data-glimmer-fav-empty]');
    var list = read();

    if (list.length === 0) {
      grid.innerHTML = '';
      empty.hidden = false;
      return;
    }
    empty.hidden = true;
    grid.setAttribute('aria-busy', 'true');

    var entries = list.map(parse);

    Promise.all(entries.map(function (entry) {
      return fetch('/products/' + encodeURIComponent(entry.handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      grid.removeAttribute('aria-busy');

      var items = [];
      products.forEach(function (p, i) {
        if (p) { items.push({ product: p, saved: entries[i] }); }
      });

      // Produto apagado ou indisponível na loja: tira da lista (mantendo a variante dos outros).
      if (items.length !== entries.length) {
        write(items.map(function (it) { return entryFor(it.saved.handle, it.saved.variant); }));
        refresh();
      }
      if (items.length === 0) { grid.innerHTML = ''; empty.hidden = false; return; }

      grid.innerHTML = items.map(function (it) {
        var p = it.product;
        var parts = p.title.split(' - ');
        var brand = parts.length > 1 ? parts.shift() : '';
        var name = parts.join(' - ');

        // Variante salva (se ainda existir); senão, a primeira disponível.
        var savedVariant = it.saved.variant ? p.variants.find(function (v) { return v.id === it.saved.variant; }) : null;
        var variant = savedVariant || p.variants.find(function (v) { return v.available; }) || p.variants[0];
        var showOption = savedVariant && p.variants.length > 1 && variant.title !== 'Default Title';

        var imageSrc = (savedVariant && savedVariant.featured_image && savedVariant.featured_image.src) || p.featured_image;
        var image = sizedImage(imageSrc, '400x');
        var url = p.url + (savedVariant ? '?variant=' + savedVariant.id : '');

        var action;
        if (variant.available) {
          action = '<button type="button" class="glimmer-fav-card__add" data-glimmer-fav-add="' + variant.id + '">Adicionar à sacola</button>';
        } else if (savedVariant && p.available) {
          action = '<a class="glimmer-fav-card__soldout glimmer-fav-card__soldout--link" href="' + p.url + '">Esgotado nesta opção · ver outras</a>';
        } else {
          action = '<span class="glimmer-fav-card__soldout">Esgotado</span>';
        }

        return '' +
          '<article class="glimmer-fav-card">' +
            '<a class="glimmer-fav-card__image" href="' + url + '">' +
              (image ? '<img src="' + image + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
            '</a>' +
            '<button type="button" class="glimmer-fav-btn glimmer-fav-btn--card is-active" data-glimmer-fav="' + escapeHtml(p.handle) + '"' +
              (savedVariant ? ' data-glimmer-fav-variant="' + savedVariant.id + '"' : '') +
              ' aria-pressed="true" aria-label="Remover dos favoritos">' + HEART + '</button>' +
            '<div class="glimmer-fav-card__info">' +
              (brand ? '<span class="glimmer-fav-card__brand">' + escapeHtml(brand) + '</span>' : '') +
              '<a class="glimmer-fav-card__name" href="' + url + '">' + escapeHtml(name) + '</a>' +
              (showOption ? '<span class="glimmer-fav-card__option">' + escapeHtml(variant.title) + '</span>' : '') +
              '<span class="glimmer-fav-card__price">' + money(variant.price) + '</span>' +
            '</div>' +
            action +
          '</article>';
      }).join('');
    });
  }

  // "Adicionar à sacola" na página de favoritos: entra como Integral (o cliente troca no carrinho).
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-glimmer-fav-add]');
    if (!btn) { return; }
    event.preventDefault();
    btn.disabled = true;
    btn.textContent = 'Adicionando...';
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(btn.getAttribute('data-glimmer-fav-add'), 10), quantity: 1, properties: { Pagamento: 'Integral' } })
    }).then(function (r) {
      if (!r.ok) { throw new Error('add'); }
      window.location.href = (window.routes && window.routes.cartUrl) || '/cart';
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Adicionar à sacola';
      toast('Não foi possível adicionar. Tente novamente.');
    });
  });

  // Coração compartilhado com a página de favoritos (mesmo desenho do snippet glimmer-fav-button).
  var HEART = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 8 3.4 4.5 6.9 4.5c2 0 3.5 1.1 5.1 3 1.6-1.9 3.1-3 5.1-3 3.5 0 5.5 3.5 4.2 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>';

  window.GlimmerFavoritos = { list: read, has: has, toggle: toggle, refresh: refresh, parse: parse };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refresh(); renderPage(); });
  } else {
    refresh();
    renderPage();
  }
})();
